import { render, staticRenderFns } from "./ManageCompanyRolesPage.vue?vue&type=template&id=57a973aa&scoped=true"
import script from "./ManageCompanyRolesPage.vue?vue&type=script&lang=ts"
export * from "./ManageCompanyRolesPage.vue?vue&type=script&lang=ts"
import style0 from "./ManageCompanyRolesPage.vue?vue&type=style&index=0&id=57a973aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a973aa",
  null
  
)

export default component.exports